import * as bootstrap from "bootstrap" 
import {randomId} from '../lib/ChoiceUtils'
import * as _ from 'lodash'
import { serverEnvironment } from './Environment';
import { EnvironmentType } from "../Enums/ChoiceEnums";
import { DisplayStyle } from "../Enums/UiEnums";

// Display a modal window via iframe
export async function popIframe(iframe_source: string, titleHTML?: string, modal_class?: string, modal_height_percent?: number, display_footer?: boolean, maxHeight?: number)
{ 
    let new_height = window.innerHeight * (modal_height_percent ?? .90);
    if (maxHeight) {
        if (new_height > maxHeight) {
            new_height = maxHeight;
        }
    }
    const footer_display = (display_footer ? "block" : "none");

    return showBootstrapDialog(
        `<div class="modal" tabindex="-1" id="ConfirmationDialog">
            <div class="modal-dialog ${modal_class ?? ""}">
                <div class="modal-content" style="height: ${new_height}px;">
                    <div class="modal-header">
                        <h5 class="modal-title">${titleHTML ?? "OfficeMD"}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <IFRAME id="ConfirmationDialog_Frame" frameborder="0" title="" src="${iframe_source}" style="height:100%; width: 100%;"></IFRAME>
                    </div>
                    <div class="modal-footer" style="display: ${footer_display};" >
                        <button type="button" class="btn btn-primary" id="ConfirmationDialog_Confirm">Close</button>
                    </div>
                </div>
            </div>
        </div>`);
}
// Display a message
export async function popAlert(messageHTML: string, titleHTML?: string, styleOption?: ModalStyles)
{ 
    let title_class = ""; 

    switch (styleOption) {
        case ModalStyles.danger: 
            title_class = "text-danger"; 
            break;        
        case ModalStyles.warning: 
            title_class = "text-warning"; 
            break;       
        case ModalStyles.info: 
            title_class = "text-info"; 
            break; 
    }     

    return showBootstrapDialog(
        `<div class="modal" tabindex="-1" id="ConfirmationDialog">
            <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                <h5 class="modal-title ${title_class}">${titleHTML ?? "OfficeMD"}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                <p>${messageHTML}</p>
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-primary" id="ConfirmationDialog_Confirm">Close</button>
                </div>
            </div>
            </div>
        </div>`);
}
// Display a message during development. Helps us spot issues before deployment
export async function popDevelopmentAlert(messageHTML: string, titleHTML?: string)
{
    if (EnvironmentType.Production != serverEnvironment())
    {
        popAlert(messageHTML, titleHTML);
    }
}
// Close confirmation diaglog
export function closeConfirmDialogReject(message_id? : string) {
     /* Close Modal Window */  
    if (!message_id) {
        return;
    }
    const message_identifier = `choice-iframe-ConfirmationDialog-${message_id}`;
    const sendChannel = new BroadcastChannel(message_identifier); 
    sendChannel.postMessage({reject: true}) ;
}
export function closeConfirmDialogConfirm(message_id? : string) {
     /* Close Modal Window */ 
    if (!message_id) {
        return;
    }

    const message_identifier = `choice-iframe-ConfirmationDialog-${message_id}`;
    const sendChannel = new BroadcastChannel(message_identifier); 
    sendChannel.postMessage({confirm: true}) ;
}
// Display a confirmation message
export async function confirmDialog(messageHTML: string, options?:IConfirmDialogOptions)
{
    let content_class = "";
    let title_class = "";
    let message_class = "";

    switch (options?.modalStyle) {
        case ModalStyles.danger:
            content_class = "border-4 border-danger";
            title_class = "text-danger";
            message_class = "text-danger";
            break;        
        case ModalStyles.warning:
            content_class = "border-4 border-warning";
            title_class = "text-warning";
            message_class = "text-warning";
            break;       
        case ModalStyles.info:
            content_class = "border-4 border-info";
            title_class = "text-info";
            message_class = "text-info";
            break; 
    } 
    return showBootstrapDialog(
        `<div class="modal" tabindex="-1" id="ConfirmationDialog">
            <div class="modal-dialog">
                <div class="modal-content ${content_class}">
                    <div class="modal-header">
                    <h5 class="modal-title ${title_class}">${ options?.titleHTML ?? "Confirm"}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body ${message_class}">
                    <p>${messageHTML}</p>
                    </div>
                    <div class="modal-footer">
                    <button type="button" class="btn btn-primary" id="ConfirmationDialog_Confirm">${ options?.ConfirmText ?? "Confirm" }</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="ConfirmationDialog_Reject">${ options?.RejectText ?? "Reject" }</button>
                    </div>
                </div>
            </div>
        </div>`);
} 
export interface IConfirmDialogOptions
{
    ConfirmText: string,
    RejectText: string,
    titleHTML?: string,
    modalStyle?: ModalStyles
} 
 
export enum ModalStyles {
    ignore,
    danger,
    warning,
    info
}
interface IConfirm 
{
    confirm?: boolean;
}
interface IReject 
{
    reject?: boolean;
}
async function showBootstrapDialog(diaglogHTML: string): Promise<boolean>
{ 
    // Build a random id to replace 'ConfirmationDialog'
    // This is used for messaging.
    const r_identifier = randomId(12); 
    const replacement_id = "ConfirmationDialog_" + r_identifier;
    diaglogHTML = _.replace(diaglogHTML,  /ConfirmationDialog/gi, replacement_id); 
     
    return new Promise((resolve, _reject) => {
        const container = document.createElement("div");
        container.innerHTML = diaglogHTML;
        document.body.appendChild(container);
 
        const channel = new BroadcastChannel("choice-iframe-ConfirmationDialog-" + r_identifier);
        channel.addEventListener("message", ListenForMessageEvent); 

        const modelEle = document.getElementById(replacement_id);
        if (!modelEle)
        {
            channelCleanup(false);    
            return;
        }

        const thisModal = new bootstrap.Modal(modelEle??"");

        // Handle rejection
        function Reject()
        {
            container.remove(); // Clean up
            resolve(false);
        }
        // Handle Messages
        function ListenForMessageEvent(event: MessageEvent<IConfirm | IReject>)
        {
            channelCleanup(true); 
        }
        
        // Cleanup
        function channelCleanup(resolved: boolean) {
            channel.removeEventListener("message", ListenForMessageEvent);
            thisModal.hide();
            container.remove(); // Clean up
            resolve(resolved);
        }

        modelEle.addEventListener("hidden.bs.modal", Reject);
        document.getElementById(replacement_id + "_Reject")?.addEventListener("click", Reject);        

        // Handle confirm
        document.getElementById(replacement_id + "_Confirm")?.addEventListener("click", ()=>{
            modelEle.removeEventListener("hidden.bs.modal", Reject);
            channelCleanup(true);
        });

        thisModal.show();
    });       
}

export function showToast(msg: string, displayStyle: DisplayStyle, options?: {durationInMilliSeconds?: number, supressAlertInPopoutWindows?: boolean})
{
    const topWindow = (<any>window.top);

    // Is there a toast handler in the base/legacy application
    if (topWindow.legacyShowToastExists)
    {
        topWindow.showToast(msg, displayStyle, options?.durationInMilliSeconds ?? 5000, options?.supressAlertInPopoutWindows);
    }
    else
    {
        alert(msg);
    }        
}